<botato-chat
    [initialInputType]="'none'"
    [botId]="botId"
    endOfHistoryMessage="{{'general.endOfHistoryMessage' | translate}}"></botato-chat>
